import { useElasticData, useExtraData } from "../DataContext.js";
import {capitalizeFirstLetter} from '../../helpers.mjs';

const ResourcesPanel = ({tabIndex, sel}) => {
        
    let { productResources } = useElasticData();
        
    let { isGuestUser } = useExtraData();
    const name = `tab-${tabIndex}`;
    
    const _resources = productResources.length > 0 ? productResources.map((rs, i) => <div key={i} className="third column">
        {!isGuestUser && <>
            <a href={rs.link} className="contentItemImage" target="_blank"><img src={`/assets/img/resources/${rs.type}.jpg`} /></a>
            <a href={rs.link} target="_blank"><strong>{capitalizeFirstLetter(rs.type.replaceAll('_', ' '))}</strong></a>
        </>}
        {isGuestUser && <>
            <a className="contentItemImage" target="_blank"><img src={`/assets/img/resources/${rs.type}.jpg`} /></a>
            <a><strong>{capitalizeFirstLetter(rs.type.replaceAll('_', ' '))}</strong></a>
        </>}
        <p><strong>{rs.description}</strong></p>
    </div>) : [];
    
    return(
        <div id={`tab-${tabIndex}`} className={`tabContent ${name == sel ? "current" : ""}`}>
            <p>Click on the icons below to download your free resources.</p>
            <div id="resourcesList" className="columns wrap contentItems">
                {_resources}
            </div>
        </div>
    )
}

export default ResourcesPanel;